/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationForJiraDataCenterIncidentManagement extends models.GovernanceConfigurationBaseForJiraDataCenter {
    constructor() {
        super();
        this.setDiscriminator("GovernanceConfigurationForJiraDataCenterIncidentManagement");
    }

    getFixupPrototypeFunction() { return GovernanceConfigurationForJiraDataCenterIncidentManagement.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationForJiraDataCenterIncidentManagement>): GovernanceConfigurationForJiraDataCenterIncidentManagement {
        let obj = Object.assign(new GovernanceConfigurationForJiraDataCenterIncidentManagement(), model);
        GovernanceConfigurationForJiraDataCenterIncidentManagement.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationForJiraDataCenterIncidentManagement>): GovernanceConfigurationForJiraDataCenterIncidentManagement {
        if (!model) return null;
        return GovernanceConfigurationForJiraDataCenterIncidentManagement.newInstance(<GovernanceConfigurationForJiraDataCenterIncidentManagement> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationForJiraDataCenterIncidentManagement) {
        if (!obj) return;

        models.GovernanceConfigurationForJiraDataCenterIncidentManagement.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationForJiraDataCenterIncidentManagement): boolean {
        if (models.GovernanceConfigurationBaseForJiraDataCenter.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationForJiraDataCenterIncidentManagement.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.incident_management) {
            models.JiraDataCenterIncidentManagementConfiguration.fixupPrototype(this.incident_management);
        }
        if (this.policy_mapping) {
            models.JiraDataCenterPolicyMapping.fixupPrototype(this.policy_mapping);
        }
        if (this.alerts_mapping) {
            models.JiraDataCenterAlertMapping.fixupPrototype(this.alerts_mapping);
        }
        if (this.budget_alerts_mapping) {
            models.JiraDataCenterBudgetAlertMapping.fixupPrototype(this.budget_alerts_mapping);
        }
    }

    /**
     * Incident management for JIRA Datacenter setting
     */
    incident_management: models.JiraDataCenterIncidentManagementConfiguration;

    /**
     * Attribute mapping for JIRA Datacenter Policy
     */
    policy_mapping: models.JiraDataCenterPolicyMapping;

    /**
     * Attribute mapping for JIRA Datacenter Alerts
     */
    alerts_mapping: models.JiraDataCenterAlertMapping;

    /**
     * Attribute mapping for JIRA Datacenter Budget Alerts
     */
    budget_alerts_mapping: models.JiraDataCenterBudgetAlertMapping;

}
